import React, { FC, useEffect, useState } from 'react'
import { useStyletron } from 'parkdepot-shared/theme'
import { Link } from 'react-router-dom'
import { Question, Answer, Content } from './FaqComponent/Faq.style'

const parseHTMLString = (str: string) => {
    try {
        return str.split(/<a href='(.*?)'>(.*?)<\/a>/g).map((part, index) => {
            if (index % 3 === 0) {
                return part
            } else if (index % 3 === 1) {
                // if contains mailto
                if (part.includes('@')) {
                    return (
                        <a href={`mailto:${part}`} key={index}>
                            {part}
                        </a>
                    )
                } else {
                    return (
                        <Link to={part} key={index}>
                            {str.split(/<a href='(.*?)'>(.*?)<\/a>/g)[index + 1]}
                        </Link>
                    )
                }
            } else {
                return null
            }
        })
    } catch (error) {
        return str
    }
}

interface Props {
    contentSection: { question: string; answer: string; opened: boolean }[]
}

const Section: FC<Props> = ({ contentSection }) => {
    const [css, theme] = useStyletron()
    const [openedQuestions, setOpenedQuestions] = useState<number[]>([])

    const onQuestionClick = (index: number) => {
        if (openedQuestions.includes(index)) {
            setOpenedQuestions(openedQuestions.filter((item) => item !== index))
        } else {
            setOpenedQuestions([...openedQuestions, index])
        }
    }

    useEffect(() => {
        setOpenedQuestions([])
    }, [contentSection])

    return (
        <Content>
            {/* <Title>{title}</Title> */}
            {contentSection.map((item, index) => (
                <div key={index}>
                    <Question
                        $selected={openedQuestions.includes(index)}
                        onClick={() => {
                            onQuestionClick(index)
                        }}
                    >
                        {item.question}
                        <i
                            className={`${openedQuestions.includes(index) ? 'pkd-minus' : 'wemolo-plus'} ${css({
                                fontSize: '1.6rem'
                            })}`}
                        />
                    </Question>
                    {openedQuestions.includes(index) && <Answer>{parseHTMLString(item.answer)}</Answer>}
                </div>
            ))}
        </Content>
    )
}

export default Section
